import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TSetCommentParam, ESetCommentParamActionType, ISetCommentParam, TComment } from './types';

export const setCommentParam: <P extends keyof TComment>(data: ISetCommentParam<P>) => TSetCommentParam =
  actionGenerator<ESetCommentParamActionType.Set, ISetCommentParam>(ESetCommentParamActionType.Set);
